/**
 * Singleton de Socket.IO.
 * En local conecta directo al backend (puerto 8000).
 * En producción conecta al mismo origen y Nginx enruta /socket.io/ al backend.
 */
import { io } from "socket.io-client";

const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const SERVER_URL = isLocal
  ? `http://${window.location.hostname}:8000`
  : window.location.origin;

const socket = io(SERVER_URL, {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  autoConnect: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: Infinity,
});

export default socket;
